import { message } from "antd";
import axios from "axios";
import Api from "./Api";
import SessionService from "../services/session/SessionService";
import MessageService from "../services/message/MessageService";

const CODE_OK = "0";

const AxiosService = axios.create({
    timeout: 30000,
});

AxiosService.interceptors.request.use(
    (config) => {
        let sessionService = SessionService.getInstance();
        config.headers.Authorization = sessionService.getAuthoriazation();
        if (config.baseURL == null) {
            config.baseURL = Api.URL_PREFIX;
        }
        return config;
    },
    (error) => {
        console.log(error);
        MessageService.getInstance().showMessage('error', error);
    }
)

AxiosService.interceptors.response.use((response) => {
    let code = response.data.code;
    let message = response.data.message;

    if (code != null && code != CODE_OK) {
        MessageService.getInstance().showMessage('error', message);
        throw message;
    }

    return response;
});


export default AxiosService;